import exportacao from './exportacao'
import procedimento from './procedimento'
import relatorioInconsistencia from './relatorioInconsistencia'

export default [
    {
        path: 'raas',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...exportacao,
            ...procedimento,
            ...relatorioInconsistencia,
        ]
    }
]